import { render, staticRenderFns } from "./EnrolmentQuestionProgramTimeEditor.vue?vue&type=template&id=35f770f0&scoped=true"
import script from "./EnrolmentQuestionProgramTimeEditor.vue?vue&type=script&lang=js"
export * from "./EnrolmentQuestionProgramTimeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f770f0",
  null
  
)

export default component.exports